/* tslint:disable */
/* eslint-disable */
export enum PayPalEventDeliveryOrderByEnum {
  Id = 'Id',
  CreateTime = 'CreateTime',
  EventType = 'EventType'
}
